import React from 'react';
import { Col, Row, FormGroup, Label, Input, FormFeedback } from 'reactstrap';

// Kart numarası formatla
const formatCardNumber = (value) => {
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{4,16}/g);
    const match = matches && matches[0] || '';
    const parts = [];
    for (let i = 0; i < match.length; i += 4) {
        parts.push(match.substring(i, i + 4));
    }
    return parts.length ? parts.join(' ') : v;
};

// Yıl seçenekleri
const currentYear = new Date().getFullYear();
const years = Array.from({length: 15}, (_, i) => currentYear + i);

const CardInputSection = ({ validation, onCardNumberChange, onOwnerChange, onMonthChange, onYearChange, onCvvChange, onCvvFocus, onCvvBlur, detectedCardBrand }) => {

    return (
        <>
            <FormGroup className="mb-3">
                <Input
                    type="text"
                    placeholder="* Kart Üzerindeki İsim"
                    value={validation.values.cc_owner}
                    onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g, ""); // sadece harf ve boşluk
                        onOwnerChange({ target: { name: "cc_owner", value } });
                    }}
                    invalid={validation.touched.cc_owner && validation.errors.cc_owner}
                />
                <FormFeedback>{validation.errors.cc_owner}</FormFeedback>
            </FormGroup>

            <FormGroup className="mb-3">
                <Input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9 ]*"
                    placeholder="* Kart Numarası (Örn: 4355 0843 5508 4358)"
                    maxLength="19"
                    value={validation.values.card_number}
                    onChange={onCardNumberChange} // Dışarıdan gelen handler'ı kullan
                    invalid={validation.touched.card_number && validation.errors.card_number}
                />
                <FormFeedback>{validation.errors.card_number}</FormFeedback>
                {!detectedCardBrand && (
                    <medium className="text-muted mt-1 d-block">
                        <i className="bx bx-info-circle me-1"></i>
                        Kartınıza özel taksit opsiyonlarını görmek için lütfen kart numaranızı giriniz.
                    </medium>
                )}
            </FormGroup>

            <Row>
                <Col xs={4}>
                    <FormGroup className="mb-3">
                        <Input
                            type="select"
                            value={validation.values.expiry_month}
                            onChange={onMonthChange}
                            invalid={validation.touched.expiry_month && validation.errors.expiry_month}
                        >
                            <option value="">Ay</option>
                            {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                                <option key={month} value={month.toString().padStart(2, '0')}>
                                    {month.toString().padStart(2, '0')}
                                </option>
                            ))}
                        </Input>
                        <FormFeedback>{validation.errors.expiry_month}</FormFeedback>
                    </FormGroup>
                </Col>
                <Col xs={4}>
                    <FormGroup className="mb-3">
                        <Input
                            type="select"
                            value={validation.values.expiry_year}
                            onChange={onYearChange}
                            invalid={validation.touched.expiry_year && validation.errors.expiry_year}
                        >
                            <option value="">Yıl</option>
                            {years.map(year => (
                                <option key={year} value={year.toString().slice(-2)}>
                                    {year.toString().slice(-2)}
                                </option>
                            ))}
                        </Input>
                        <FormFeedback>{validation.errors.expiry_year}</FormFeedback>
                    </FormGroup>
                </Col>
                <Col xs={4}>
                    <FormGroup className="mb-3">
                        <Input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            placeholder="CVV"
                            maxLength="4"
                            value={validation.values.cvv}
                            onChange={onCvvChange}
                            onFocus={onCvvFocus}
                            onBlur={onCvvBlur}
                            invalid={validation.touched.cvv && validation.errors.cvv}
                        />
                        <FormFeedback>{validation.errors.cvv}</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
};

// Bu fonksiyonu da bileşen dosyasına taşıdık
CardInputSection.formatCardNumber = formatCardNumber;

export default CardInputSection;